import { initAffiliate } from './services/affiliate'
// =====================================================================
// WeddingOS – main.jsx
// =====================================================================

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/theme.css";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
